import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import { App } from "./app";
import "./styles/styles.css";
import "./styles/styles-sounds.css";
import "./styles/styles-decoded2.css";
import "./styles/styles-team.css";
import "./styles/styles-generate.css";
import "./styles/styles-staff.css";
import "./styles/styles-chief.css";
import "./styles/styles-teams.css";
import "./styles/styles-standin.css";
import "./styles/styles-history.css";
import "./styles/styles-ux.css";
import "./styles/styles-events-agent.css";
import "./styles/styles-meetings.css";
import "./styles/mivio.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
